import type { ComponentProps } from 'react';
import { Modal } from 'is24-corecss';
import { useSlots } from '../SlotContext';

/** Provides the modal's accessible name through an internally generated ID referenced by aria-labelledby. */
export const Title = (props: Omit<ComponentProps<typeof Modal.Title>, 'id'>) => {
  const { titleId } = useSlots();
  return <Modal.Title {...props} id={titleId} />;
};
